import { clearDigitsSpecialChars } from "../common/parsers";
import { formatCpf } from "../common/formaters";

export class Usuario {

    constructor(params = {}) {
        this.id = params.id || "";
        this.cpf = params.cpf ? formatCpf(params.cpf) : "";
        this.nome = params.nome || "";
        this.email = params.email || "";
        this.senha = params.senha || "";
        this.ativo = params.ativo || false;
    }

    beforeSave = () => {
        this.cpf = clearDigitsSpecialChars(this.cpf);
    }

}


// WEBPACK FOOTER //
// ./src/models/Usuario.js